module.exports = __webpack_public_path__ + "static/media/adrianRosales.568e54d1.svg";